import styles from "./DotChevron.module.scss";

const DOT_COUNT = 5;

// Five-dot chevron drawn in CSS: points down when closed, morphs to point up when open
export const DotChevron = ({ isOpen }: { isOpen: boolean }) => (
  <span
    className={`${styles["dot-chevron"]} ${isOpen ? styles["is-open"] : ""}`}
    aria-hidden="true"
  >
    {Array.from({ length: DOT_COUNT }, (_, index) => (
      <span key={index} className={styles.dot} />
    ))}
  </span>
);
